const useSortedQuestion = () => {
    const sortQuestions = (questions: any[], sortField: string = "order_column", sortDirection: string = "desc") => {
        const sortMultiplier = sortDirection === "asc" ? 1 : -1;

        return [...questions].sort((a, b) => {
            // First priority: pinned status (always descending - pinned first)
            const pinnedDiff = (b.is_pinned ? 1 : 0) - (a.is_pinned ? 1 : 0);
            if (pinnedDiff !== 0) {
                return pinnedDiff;
            }

            // Next: respect the requested sort field and direction only
            let aVal = a.question?.[sortField] || a[sortField];
            let bVal = b.question?.[sortField] || b[sortField];

            // Handle null/undefined values
            if (aVal == null) {
                return 1;
            }
            if (bVal == null) {
                return -1;
            }

            // Apply sort direction
            return (aVal > bVal ? 1 : aVal < bVal ? -1 : 0) * sortMultiplier;
        });
    };

    return {sortQuestions};
};
export default useSortedQuestion;
